import { jsx, jsxs } from "react/jsx-runtime";
import { Box, Heading, Text, Stack } from "braid-design-system";
import { jobCard } from "./JobCardLite/JobCardLite.css.mjs";
const SkeletonLine = function({
  width,
  type,
  level,
  height,
  size
}) {
  const content = type === "heading" ? /* @__PURE__ */ jsx(Heading, { component: "span", level, children: " " }) : type === "text" && /* @__PURE__ */ jsx(Text, { size, children: " " }) || null;
  return /* @__PURE__ */ jsx(
    Box,
    {
      component: "span",
      display: "block",
      borderRadius: "standard",
      background: "neutralLight",
      height: type === "button" ? "touchable" : void 0,
      style: { width, ...height ? { height } : {} },
      children: content
    }
  );
};
const CompetitiveJobsSkeleton = () => /* @__PURE__ */ jsxs(Stack, { space: "large", data: { testid: "competitive-jobs-skeleton" }, children: [
  /* @__PURE__ */ jsx(SkeletonLine, { type: "heading", width: 140, level: "4" }),
  /* @__PURE__ */ jsx(
    Box,
    {
      display: "flex",
      gap: "small",
      flexDirection: { mobile: "column", tablet: "row" },
      width: "full",
      children: /* @__PURE__ */ jsx(JobCard, {})
    }
  )
] });
const JobCard = () => /* @__PURE__ */ jsx(Box, { flexGrow: 1, paddingRight: "none", children: /* @__PURE__ */ jsxs(
  Box,
  {
    padding: "medium",
    borderRadius: "large",
    cursor: "pointer",
    position: "relative",
    width: "full",
    className: jobCard,
    children: [
      /* @__PURE__ */ jsx(SkeletonLine, { type: "button", width: 48, height: 48 }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(SkeletonLine, { type: "text", width: 100, size: "standard" }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "xsmall", children: /* @__PURE__ */ jsx(SkeletonLine, { type: "text", width: 150 }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "small", children: /* @__PURE__ */ jsx(SkeletonLine, { type: "text", width: 70, size: "small" }) }),
      /* @__PURE__ */ jsx(Box, { paddingTop: "medium", children: /* @__PURE__ */ jsx(SkeletonLine, { type: "text", width: 80, size: "small" }) }),
      /* @__PURE__ */ jsx(
        Box,
        {
          position: "absolute",
          right: 0,
          top: 0,
          paddingRight: "medium",
          paddingTop: "medium",
          children: /* @__PURE__ */ jsx(SkeletonLine, { type: "button", width: 16, height: 16 })
        }
      )
    ]
  }
) });
export {
  CompetitiveJobsSkeleton,
  SkeletonLine
};
